import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {watch} from "vue";
import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import {ref} from "vue";

interface Props {
  modelValue?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MemoEditComponent',
  props: {
    modelValue: { default: undefined }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const _form = ref<InstanceType<typeof SogForm> | null>(null);

const _value = ref<string | undefined>(undefined);
const _emits = __emit;
watch(
  props,
  () => {
    _value.value = props.modelValue;
  },
  {immediate: true}
);
const validate = (): boolean => {
  if (_form.value) return _form.value.validate();
  return false;
};

function onUpdate(args: any) {
  _emits("update:modelValue", args);
}

__expose({
  validate,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogForm, {
    ref_key: "_form",
    ref: _form
  }, {
    default: _withCtx(() => [
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _value.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((_value).value = $event)),
              onUpdate
            ],
            placeholder: "Bemerkung",
            multiline: "true",
            width: "200px"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})